export default class BaseForm {
    components;
    constructor(..._args) {
        this.components = [];
    }
}
